<script type="text/javascript">
export default {
    props: {
        giftcard: {
            required: true,
        },
    },

    computed: {
        description_formatted() {
            return this.giftcard.description.replace(/\n/g, "<br />");
        },
        combinedStyles() {
            const styles = {
                '--giftcard-text-color': `${this.giftcard.text_color || '#FFFFFF'}`
            };
            if (this.giftcard.design === 0 && this.giftcard.background_image_url) {
                styles['background-image'] = `url(${this.giftcard.background_image_url})!important`;
            }
            return styles;
        },
    },
};
</script>

<template id="show-giftcard">

    <div id="client-gift-card"
         class="client-gift-card"
         :class="'giftcard-color-'+giftcard.design"
         :style="combinedStyles"
    >
        <div class="gift-card-heading">
            <h3 class="gift-card-title pull-left">{{ giftcard.name }}</h3>
            <h4 class="gift-card-subtitle">{{ giftcard.user.realname }}</h4>
            <h4 class="gift-card-subtitle m-0" v-if="giftcard.expires_at">{{ trans('giftcards.expires_on') }} {{ $filters.humanize_date(giftcard.expires_at)  }}</h4>
        </div>
        <div class="gift-card-cost" v-if="giftcard.product">
            <small class="gift-card-subtitle-money-left">{{ trans('giftcards.type_product') }}</small>
            <h1 class="gift-card-price">{{ giftcard.product.name }}</h1>
        </div>
        <div class="gift-card-cost" v-else>
            <h1 class="gift-card-price"><small>{{ giftcard.currency }}</small>  {{ giftcard.price_with_vat_formatted }}</h1>
            <small class="gift-card-subtitle-money-left" v-if="giftcard.status !== 'not_used'">{{ trans('giftcards.amount_left', { amount: giftcard.money_left_formatted }) }}</small>
        </div>
        <div class="gift-card-identifier">
            {{ giftcard.identifier }}
        </div>
        <p class="gift-card-desc" v-sanitize-html="description_formatted"></p>

        <div class="wave">
            <div class="wave-wrapper"><div class="wave1 wave-animation"></div></div>
            <div class="wave-wrapper"><div class="wave2 wave-animation"></div></div>
            <div class="wave-wrapper"><div class="wave3 wave-animation"></div></div>
        </div>

    </div>

</template>
